import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CUSpinnerService {
  // This is a smaller spinner, non fullpage.
  /**
   * Spinner observable
   *
   * @memberof CUSpinnerService
   */
  public spinnerObservable = new Subject<boolean>();
  /**
   * Creates an instance of CUSpinnerService.
   * @memberof CUSpinnerService
   */
  constructor() {}
  /**
   * To show spinner
   *
   * @memberof CUSpinnerService
   */
  public show() {
    this.spinnerObservable.next(true);
  }
  /**
   * To hide spinner
   *
   * @memberof CUSpinnerService
   */
  public hide() {
    this.spinnerObservable.next(false);
  }
}
